import React from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../components/layout";
import PortalSettings from "../components/features/portal/PortalSettings";
import IpAllowlistSettings from "../components/features/access/IpAllowlistSettings";
import { useIsProCloudPlan, useUserStore } from "../store/userStore";
import { updatePortalAccess } from "../services/api";
import type { IpAllowlistEntry } from "../types";
import { Alert, AlertDescription } from "@/components/ui";

const PortalSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const { properties, updateProperties } = useUserStore();
  const isProCloudPlan = useIsProCloudPlan();
  const breadcrumbs = [
    // { title: 'Dashboard', href: 'dashboard' },
    { title: t('sidebar.guidesBranding'), isCurrentPage: true }
  ];
  const portalSettings = properties?.portal?.settings;
  //const isProCloudPlan = properties?.subscription?.plan === 'pro-cloud';

  const handleAccessSave = async (params: { enabled: boolean; entries: IpAllowlistEntry[] }) => {
    const response = await updatePortalAccess(params);
    if (response.ok && response.properties?.portal) {
      updateProperties({ portal: response.properties.portal });
    }
    return {
      ok: response.ok,
      errors: response.errors,
      entryErrors: response.entryErrors,
      entries: response.properties?.portal?.settings?.ipAllowlist,
    };
  };

  return (
    <AppLayout showSidebar={true} breadcrumbs={breadcrumbs}>
      <div className="p-4 min-w-[650px] max-w-[750px] mx-auto">
        <div className="mb-3 ">
          <h1 className="text-xl font-bold text-foreground">{t('sidebar.guidesBranding')}</h1>
          <Alert variant="info" className="mt-3 mb-3">
            <AlertDescription>
              {t('sharedGuides.linkOnlyNote')}
            </AlertDescription>
          </Alert>
        </div>

        <h2 className="text-base font-semibold text-foreground mb-2">{t('sharedGuides.appearance')}</h2>
        <PortalSettings
          settings={portalSettings}
          isProCloudPlan={isProCloudPlan}
          context="guide"
        />

        <h2 className="text-base font-semibold text-foreground mb-2">{t('sharedGuides.access')}</h2>
        <div className="bg-white border rounded-md p-8 mb-6">
          <IpAllowlistSettings
            enabled={!!portalSettings?.ipAllowlistEnabled}
            entries={portalSettings?.ipAllowlist || []}
            isProCloudPlan={isProCloudPlan}
            scope="shared-guides"
            onSave={handleAccessSave}
          />
        </div>
      </div>
    </AppLayout>
  );
};

export default PortalSettingsPage;
